import BaseUseCase from "../../base_use_case.js";

class ShowPageUseCase extends BaseUseCase {

  execute(identifier) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/admin/downloadables/downloadables/${identifier}`,
      params: {
        findBySlug: true
      },
    });
  }
}

const instance = new ShowPageUseCase();
export default instance;
